/******************************************************************
 * DeviceUtils
 *
 * @author matthias.schulz@jash.de
 *****************************************************************/

export class DeviceUtils {

    /******************************************************************
     * Public Methodes
     *****************************************************************/

    public static get GET_PORTAIT_SCREEN_WIDTH(): number {
        let appWidth = screen.width;
        if (screen.height < screen.width) {
            appWidth = screen.height;
        }
        return appWidth;
    };

    public static get HAS_TOUCH_SCREEN(): boolean {
        return navigator.maxTouchPoints > 0 || 'ontouchstart' in window;
    }

    public static get IS_IOS(): boolean {
        return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window['MSStream'];
    }

    public static get IS_MOBILE(): boolean {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    public static get IS_IE(): boolean {
        let ieVersion = this.getInternetExplorerVersion();
        return (ieVersion == 10 || ieVersion == 11);
    }

    public static get IS_IE_OR_EDGE(): boolean {
        return this.IS_IE || this.IS_EDGE;
    }

    public static get IS_FIREFOX(): boolean {
        return navigator.userAgent.search("Firefox") != -1;
    }

    public static get IS_EDGE(): boolean {
        return navigator.userAgent.search("Edge") != -1;
    }

    public static get IS_WINDOWS(): boolean {
        return navigator.platform.toUpperCase().indexOf('WIN') > -1
    }

    public static get IS_MAC(): boolean {
        return navigator.platform.toUpperCase().indexOf('MAC')>=0;
    }

    public static get IS_WINDOWS_MOBILE(): boolean {
        let isWindowsMobile = false;
        if(navigator.userAgent.match(/Windows Phone/i)){
            isWindowsMobile = true;
        }
        if(navigator.userAgent.match(/iemobile/i)){
            isWindowsMobile = true;
        }
        if(navigator.userAgent.match(/WPDesktop/i)){
            isWindowsMobile = true;
        }
        return isWindowsMobile;
    }

    public static get IS_BROWSER_SUPPORTED(): boolean {
        let isSupported = true;
        if (DeviceUtils.IS_WINDOWS_MOBILE) {
            isSupported = false;
        }
        if (DeviceUtils.HAS_TOUCH_SCREEN && DeviceUtils.IS_EDGE) { // should match MS Surface
            isSupported = false;
        }
        return isSupported;
    }

    /******************************************************************
     * Private Methodes
     *****************************************************************/

    private static getInternetExplorerVersion() {
        let rv = -1;
        if (navigator.appName == 'Microsoft Internet Explorer') {
            let ua = navigator.userAgent;
            let re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
            if (re.exec(ua) != null)
                rv = parseFloat(RegExp.$1);
        }
        else if (navigator.appName == 'Netscape') {
            let ua = navigator.userAgent;
            let re = new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})");
            if (re.exec(ua) != null)
                rv = parseFloat(RegExp.$1);
        }
        return rv;
    }


}
